import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

import { Language } from "./language/language.enum";

/**
 * Any manipulation of the DOM via a service should only happen via the {@link DocumentObjectModelService}.
 *
 * DOM manipulations from an Angular service which is not explicitly called can be misleading when troubleshooting certain behavior.
 * We should use it with caution.
 */
@Injectable({ providedIn: "root" })
export class DocumentObjectModelService {
  constructor(
    private meta: Meta,
    private title: Title,
  ) {}

  /**
   * Sets the <html lang="de"> language attribute.
   */
  setDocumentLanguage(language: Language) {
    document.documentElement.lang = language;
  }

  setDescriptionMetaTag(content: string) {
    this.setMetaTag(MetaTagName.DESCRIPTION, content);
  }

  setMetaTag(metaTagName: MetaTagName, content: string) {
    this.meta.updateTag({
      name: metaTagName,
      content: content,
    });
  }

  setHtmlTitle(title: string) {
    this.title.setTitle(title);
  }

  getHtmlTitle() {
    return this.title.getTitle();
  }
}

export enum MetaTagName {
  /**
   * https://developer.chrome.com/docs/lighthouse/seo/meta-description
   */
  DESCRIPTION = "description",
}
